export default {"src":"/login-app/[GIT_HASH]/_next/static/media/team.accb2cfc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};